<button [attr.type]="type" [class]="classes" [disabled]="disabled">
  <ng-content></ng-content>
</button>
